import { ComponentPropsWithoutRef } from "react";
import { FieldInputProps } from "formik";
import { Moment } from "moment";
import { Radio, RadioGroup, Label, Field } from "@headlessui/react";
import FormRadio from "components/elements/Forms/FormRadio";
import { classes } from "lib/actions/util";

export default function SpeckleRadioInputVersions(
  p: FieldInputProps<string> &
    ComponentPropsWithoutRef<typeof FormRadio> & {
      model: string;
      items: { value: string; label: string; date: Moment; hash: string }[];
      onSelect?(value: string): void;
    },
) {
  const { model, items, onSelect, onChange, value, ...rest } = p;

  function handleChange(newValue: string) {
    onChange(newValue);
    onSelect?.(newValue);
  }

  if (!items) return null;

  if (items.length === 0)
    return <div className="text-center text-sm text-gray-400">None</div>;

  return (
    <RadioGroup
      value={value}
      onChange={handleChange}
      className="flex flex-col gap-2"
      {...rest}
    >
      <div className="select-none rounded-md border p-4 font-light shadow-sm">
        {model}
      </div>
      {items.map((x) => (
        <VersionCard key={x.value} {...x} />
      ))}
    </RadioGroup>
  );
}

function VersionCard(p: {
  value: string;
  label: string;
  date: Moment;
  hash: string;
}) {
  const dateFormatted = p.date && p.date.format("HH:mm [᛫] ll");
  const hasLabel = !!p.label?.replace(" ", "");

  return (
    <Field>
      <div
        className="my-2 select-none rounded-md border p-4 font-light shadow-sm
          hui-checked:border-[#047efb] hui-disabled:text-gray-400 
          hui-not-disabled:cursor-pointer hui-not-disabled:hover:bg-gray-50"
      >
        <div className="flex items-start gap-3">
          <Radio
            value={p.value}
            className="hui-focus:ring-2 hui-focus:ring-[#047efb] hui-focus:ring-offset-2 mt-1 h-4 w-4 flex-shrink-0
              rounded-full border
              border-gray-300 hui-checked:border-[#047efb] hui-checked:bg-[#047efb]"
          >
            <span className="hidden h-full w-full scale-[0.4] rounded-full bg-white hui-checked:block"></span>
          </Radio>
          <Label className="flex-1 cursor-[inherit]">
            <div className="space-y-2">
              <div className={classes(!hasLabel && "italic text-neutral-400")}>
                {hasLabel ? p.label : "No message"}
              </div>
              <p className="flex justify-between text-xs text-neutral-600">
                <span>{dateFormatted}</span>
                <span className="min-w-0 overflow-ellipsis">{p.hash}</span>
              </p>
            </div>
          </Label>
        </div>
      </div>
    </Field>
  );
}
